module.exports = __webpack_public_path__ + "static/img/技术服务-1.a573ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/技术服务-1.jpg
// module id = /D6V
// module chunks = 0